import { createContext } from "react";

const UserPrefsContext = new createContext();

export default UserPrefsContext;
